import { Bancos } from './IBancos'
import { CreditoImobiliario, Enriquecimento } from '@/interfaces'
import { Constants } from '../services/constants'
import { Generico } from './IGenerico'

export namespace Atta {
	/**
	 * @deprecated NAO UTILIZAR MAIS O NAMESPACE ATTA E NEM ESTA INTERFACE
	 */
	export interface ICliente {
		id: number
		cpf: number
		nomeCliente: string
		dtNascimento: string
		vlRendaMensal: number
		email: string
		extractedFromSPC: string
		extractedFromEnriquecimento: string

		fillProfession: boolean
		idConjuge: number
		tipoCliente: number
		dsSexo: string
		nmPai: string
		nmMae: string
		uniaoEstavel: boolean
		dtCasamentoUniaoEstavel: string
		dsRegimeCasamentoUniaoEstavel: string
		estadoCivil: string
		dsRegimeCasamentoUniao: string
		dsNacionalidade: string
		dsNaturalidade: string
		nrRg: string
		dsOrgaoExpedidorRg: string
		dtEmissaoRg: string
		nmEndereco: string
		nrEndereco: string
		dsComplemento: string
		nmBairro: string
		nmCidade: string
		nrCep: string
		sglUf: string
		dsTempoResidencia: string
		dsTipoResidencia: string
		nrTelefone: string
		nrCelular: string
		vlOutraRendaMensal: number
		dsOrigemOutraRendaMensal: string
		dsTipoRendimentoAnual: string
		dsPeriodicidadeRendimentoAnual: string
		dsOutroRendimentoAnual: string
		dsFilho: number
		qtFilho: number
		nmReferenciaPessoal: string
		nrTelefoneReferenciaPessoal: string
		nrCelularReferenciaPessoal: string
		nmReferenciaComercial: string
		nrTelefoneReferenciaComercial: string
		nrCelularReferenciaComercial: string
		nrInss: string
		vlRendimentoAnualInss: number
		vlPatrimonio: number
		dsGrauIntrucao: number
		nmBanco: string
		nrAgencia: string
		nrDigitoAgencia: number
		nrConta: string
		nrDigitoConta: number
		dsImovelFinanciadoSfh: number
		dsImovelMunicipioResidente: number
		dsImovelOndeExerceOcupacao: number
		dsImovelMunicipioOndeAdquirir: number
		dtCadastro: string
		dtInativo: string
		nmPais: string
		vlRendaFamiliar: number
		idTipoPessoa: number
		dsAmericano: number
		dsPoliticamenteExposto: number
		dsMantemUniaoEstavel: number
		dsAltura: string
		dsPeso: string
		dsProfissaoPrincipalFonteRenda: number
		dsSocioEmrpesa: number
		idBanco: number
		idBanco2: number
		nmBanco2: string
		nrAgencia2: string
		nrDigitoAgencia2: number
		nrConta2: string
		nrDigitoConta2: number
		idBanco3: number
		nmBanco3: string
		nrAgencia3: string
		nrDigitoAgencia3: number
		nrConta3: string
		nrDigitoConta3: number
		idBanco4: number
		nmBanco4: string
		nrAgencia4: string
		nrDigitoAgencia4: number
		nrConta4: string
		nrDigitoConta4: number
		idBanco5: number
		nmBanco5: string
		nrAgencia5: string
		nrDigitoAgencia5: number
		nrConta5: string
		nrDigitoConta5: number
		dsCargo: string
		dsTipoContratacao: string
		dtAdmissao: string
		nrCnpjEmpresa: string
		dsNomeEmpresa: string
		dsOrigemOutraRendaMensal1: string
		dsProfissao: string
		nrCnpjSocioProprietario: string
		tipoDocto: string
		nroDocto: string
		orgaoExpedidorDocto: string
		dataEmissaoDocto: string
		nroInss: string
		ufNascimento: string

		isConjuge: boolean | null

		compoeRenda: boolean
		conjuge: ICliente | null
		posicao: number

		orgaoExpedidorUf: string
		dddCelular: string
		razaoSocial: string
		atividade: string
		dataFundacao: string
		tipoTelefone: number
		comprovarRendaMensal: number
		pessoaPoliticamenteExposta: number
	}

	export class Cliente implements ICliente {
		id: number
		cpf: number
		extractedFromSPC: string
		dtNascimento: string
		extractedFromEnriquecimento: string
		nomeCliente: string
		email: string
		vlRendaMensal: number

		fillProfession: boolean
		idConjuge: number
		tipoCliente: number
		dsSexo: string
		nmPai: string
		nmMae: string
		uniaoEstavel: boolean
		dtCasamentoUniaoEstavel: string
		dsRegimeCasamentoUniaoEstavel: string
		estadoCivil: string
		dsRegimeCasamentoUniao: string
		dsNacionalidade: string
		dsNaturalidade: string
		nrRg: string
		dsOrgaoExpedidorRg: string
		dtEmissaoRg: string
		nmEndereco: string
		nrEndereco: string
		dsComplemento: string
		nmBairro: string
		nmCidade: string
		nrCep: string
		sglUf: string
		dsTempoResidencia: string
		dsTipoResidencia: string
		nrTelefone: string
		nrCelular: string
		vlOutraRendaMensal: number
		dsOrigemOutraRendaMensal: string
		dsTipoRendimentoAnual: string
		dsPeriodicidadeRendimentoAnual: string
		dsOutroRendimentoAnual: string
		dsFilho: number
		qtFilho: number
		nmReferenciaPessoal: string
		nrTelefoneReferenciaPessoal: string
		nrCelularReferenciaPessoal: string
		nmReferenciaComercial: string
		nrTelefoneReferenciaComercial: string
		nrCelularReferenciaComercial: string
		nrInss: string
		vlRendimentoAnualInss: number
		vlPatrimonio: number
		dsGrauIntrucao: number
		nmBanco: string
		nrAgencia: string
		nrDigitoAgencia: number
		nrConta: string
		nrDigitoConta: number
		dsImovelFinanciadoSfh: number
		dsImovelMunicipioResidente: number
		dsImovelOndeExerceOcupacao: number
		dsImovelMunicipioOndeAdquirir: number
		dtCadastro: string
		dtInativo: string
		nmPais: string
		vlRendaFamiliar: number
		idTipoPessoa: number
		dsAmericano: number
		dsPoliticamenteExposto: number
		dsMantemUniaoEstavel: number
		dsAltura: string
		dsPeso: string
		dsProfissaoPrincipalFonteRenda: number
		dsSocioEmrpesa: number
		idBanco: number
		idBanco2: number
		nmBanco2: string
		nrAgencia2: string
		nrDigitoAgencia2: number
		nrConta2: string
		nrDigitoConta2: number
		idBanco3: number
		nmBanco3: string
		nrAgencia3: string
		nrDigitoAgencia3: number
		nrConta3: string
		nrDigitoConta3: number
		idBanco4: number
		nmBanco4: string
		nrAgencia4: string
		nrDigitoAgencia4: number
		nrConta4: string
		nrDigitoConta4: number
		idBanco5: number
		nmBanco5: string
		nrAgencia5: string
		nrDigitoAgencia5: number
		nrConta5: string
		nrDigitoConta5: number
		dsCargo: string
		dsTipoContratacao: string
		dtAdmissao: string
		nrCnpjEmpresa: string
		dsNomeEmpresa: string
		dsOrigemOutraRendaMensal1: string
		dsProfissao: string
		nrCnpjSocioProprietario: string
		tipoDocto: string
		nroDocto: string
		orgaoExpedidorDocto: string
		dataEmissaoDocto: string
		nroInss: string
		ufNascimento: string

		isConjuge: boolean | null

		compoeRenda: boolean
		conjuge: ICliente | null
		posicao: number

		orgaoExpedidorUf: string
		dddCelular: string
		razaoSocial: string
		atividade: string
		dataFundacao: string
		tipoTelefone: number
		comprovarRendaMensal: number
		pessoaPoliticamenteExposta: number

		get EnriquecimentoDados() {
			if (this.extractedFromEnriquecimento) {
				let dados = JSON.parse(this.extractedFromEnriquecimento)

				var key,
					keys = Object.keys(dados)
				var n = keys.length
				var newobj = {} as any
				while (n--) {
					key = keys[n]
					newobj[key.toLowerCase()] = dados[key]
				}

				return newobj as Enriquecimento.Resultado
			}

			return
		}

		constructor(cliente: ICliente) {
			this.id = cliente.id
			this.extractedFromEnriquecimento = cliente.extractedFromEnriquecimento
			this.extractedFromSPC = cliente.extractedFromSPC
			this.cpf = cliente.cpf
			this.nomeCliente = cliente.nomeCliente
			this.email = cliente.email
			this.vlRendaMensal = cliente.vlRendaMensal
			this.dtNascimento = cliente.dtNascimento

			this.fillProfession = cliente.fillProfession
			this.idConjuge = cliente.idConjuge
			this.tipoCliente = cliente.tipoCliente
			this.dsSexo = cliente.dsSexo
			this.nmPai = cliente.nmPai
			this.nmMae = cliente.nmMae
			this.uniaoEstavel = cliente.uniaoEstavel
			this.dtCasamentoUniaoEstavel = cliente.dtCasamentoUniaoEstavel
			this.dsRegimeCasamentoUniaoEstavel = cliente.dsRegimeCasamentoUniaoEstavel
			this.estadoCivil = cliente.estadoCivil
			this.dsRegimeCasamentoUniao = cliente.dsRegimeCasamentoUniao
			this.dsNacionalidade = cliente.dsNacionalidade
			this.dsNaturalidade = cliente.dsNaturalidade
			this.nrRg = cliente.nrRg
			this.dsOrgaoExpedidorRg = cliente.dsOrgaoExpedidorRg
			this.dtEmissaoRg = cliente.dtEmissaoRg
			this.nmEndereco = cliente.nmEndereco
			this.nrEndereco = cliente.nrEndereco
			this.dsComplemento = cliente.dsComplemento
			this.nmBairro = cliente.nmBairro
			this.nmCidade = cliente.nmCidade
			this.nrCep = cliente.nrCep
			this.sglUf = cliente.sglUf
			this.dsTempoResidencia = cliente.dsTempoResidencia
			this.dsTipoResidencia = cliente.dsTipoResidencia
			this.nrTelefone = cliente.nrTelefone
			this.nrCelular = cliente.nrCelular
			this.vlOutraRendaMensal = cliente.vlOutraRendaMensal
			this.dsOrigemOutraRendaMensal = cliente.dsOrigemOutraRendaMensal
			this.dsTipoRendimentoAnual = cliente.dsTipoRendimentoAnual
			this.dsPeriodicidadeRendimentoAnual = cliente.dsPeriodicidadeRendimentoAnual
			this.dsOutroRendimentoAnual = cliente.dsOutroRendimentoAnual
			this.dsFilho = cliente.dsFilho
			this.qtFilho = cliente.qtFilho
			this.nmReferenciaPessoal = cliente.nmReferenciaPessoal
			this.nrTelefoneReferenciaPessoal = cliente.nrTelefoneReferenciaPessoal
			this.nrCelularReferenciaPessoal = cliente.nrCelularReferenciaPessoal
			this.nmReferenciaComercial = cliente.nmReferenciaComercial
			this.nrTelefoneReferenciaComercial = cliente.nrTelefoneReferenciaComercial
			this.nrCelularReferenciaComercial = cliente.nrCelularReferenciaComercial
			this.nrInss = cliente.nrInss
			this.vlRendimentoAnualInss = cliente.vlRendimentoAnualInss
			this.vlPatrimonio = cliente.vlPatrimonio
			this.dsGrauIntrucao = cliente.dsGrauIntrucao
			this.nmBanco = cliente.nmBanco
			this.nrAgencia = cliente.nrAgencia
			this.nrDigitoAgencia = cliente.nrDigitoAgencia
			this.nrConta = cliente.nrConta
			this.nrDigitoConta = cliente.nrDigitoConta
			this.dsImovelFinanciadoSfh = cliente.dsImovelFinanciadoSfh
			this.dsImovelMunicipioResidente = cliente.dsImovelMunicipioResidente
			this.dsImovelOndeExerceOcupacao = cliente.dsImovelOndeExerceOcupacao
			this.dsImovelMunicipioOndeAdquirir = cliente.dsImovelMunicipioOndeAdquirir
			this.dtCadastro = cliente.dtCadastro
			this.dtInativo = cliente.dtInativo
			this.nmPais = cliente.nmPais
			this.vlRendaFamiliar = cliente.vlRendaFamiliar
			this.idTipoPessoa = cliente.idTipoPessoa
			this.dsAmericano = cliente.dsAmericano
			this.dsPoliticamenteExposto = cliente.dsPoliticamenteExposto
			this.dsMantemUniaoEstavel = cliente.dsMantemUniaoEstavel
			this.dsAltura = cliente.dsAltura
			this.dsPeso = cliente.dsPeso
			this.dsProfissaoPrincipalFonteRenda = cliente.dsProfissaoPrincipalFonteRenda
			this.dsSocioEmrpesa = cliente.dsSocioEmrpesa
			this.idBanco = cliente.idBanco
			this.idBanco2 = cliente.idBanco2
			this.nmBanco2 = cliente.nmBanco2
			this.nrAgencia2 = cliente.nrAgencia2
			this.nrDigitoAgencia2 = cliente.nrDigitoAgencia2
			this.nrConta2 = cliente.nrConta2
			this.nrDigitoConta2 = cliente.nrDigitoConta2
			this.idBanco3 = cliente.idBanco3
			this.nmBanco3 = cliente.nmBanco3
			this.nrAgencia3 = cliente.nrAgencia3
			this.nrDigitoAgencia3 = cliente.nrDigitoAgencia3
			this.nrConta3 = cliente.nrConta3
			this.nrDigitoConta3 = cliente.nrDigitoConta3
			this.idBanco4 = cliente.idBanco4
			this.nmBanco4 = cliente.nmBanco4
			this.nrAgencia4 = cliente.nrAgencia4
			this.nrDigitoAgencia4 = cliente.nrDigitoAgencia4
			this.nrConta4 = cliente.nrConta4
			this.nrDigitoConta4 = cliente.nrDigitoConta4
			this.idBanco5 = cliente.idBanco5
			this.nmBanco5 = cliente.nmBanco5
			this.nrAgencia5 = cliente.nrAgencia5
			this.nrDigitoAgencia5 = cliente.nrDigitoAgencia5
			this.nrConta5 = cliente.nrConta5
			this.nrDigitoConta5 = cliente.nrDigitoConta5
			this.dsCargo = cliente.dsCargo
			this.dsTipoContratacao = cliente.dsTipoContratacao
			this.dtAdmissao = cliente.dtAdmissao
			this.nrCnpjEmpresa = cliente.nrCnpjEmpresa
			this.dsNomeEmpresa = cliente.dsNomeEmpresa
			this.dsOrigemOutraRendaMensal1 = cliente.dsOrigemOutraRendaMensal1
			this.dsProfissao = cliente.dsProfissao
			this.nrCnpjSocioProprietario = cliente.nrCnpjSocioProprietario
			this.tipoDocto = cliente.tipoDocto
			this.nroDocto = cliente.nroDocto
			this.orgaoExpedidorDocto = cliente.orgaoExpedidorDocto
			this.dataEmissaoDocto = cliente.dataEmissaoDocto
			this.nroInss = cliente.nroInss
			this.ufNascimento = cliente.ufNascimento

			this.isConjuge = cliente.isConjuge

			this.compoeRenda = cliente.compoeRenda
			this.conjuge = cliente.conjuge
			this.posicao = cliente.posicao
			this.orgaoExpedidorUf = cliente.orgaoExpedidorUf
			this.dddCelular = cliente.dddCelular
			this.razaoSocial = cliente.razaoSocial
			this.atividade = cliente.atividade
			this.dataFundacao = cliente.dataFundacao
			this.tipoTelefone = cliente.tipoTelefone
			this.comprovarRendaMensal = cliente.comprovarRendaMensal
			this.pessoaPoliticamenteExposta = cliente.pessoaPoliticamenteExposta
		}
	}

	export enum RatingAtta {
		A = 'A',
		B = 'B',
		C = 'C',
		D = 'D',
		E = 'E'
	}

	export enum RatingAttaPts {
		A = 37,
		B = 32,
		C = 24,
		D = 14,
		E = 0
	}

	export class Rating {
		ScoreItau?: string
		ScoreBradesco?: string
		ScoreSantander?: string
		SPCScore?: number

		constructor(scores: CreditoImobiliario.IScoreItemResponse[], spcScore: number) {
			const itau = scores.find((u) => u.fornecedorId == Constants.BANCOS.ITAU)
			const bradesco = scores.find((u) => u.fornecedorId == Constants.BANCOS.BRADESCO)
			const santander = scores.find((u) => u.fornecedorId == Constants.BANCOS.SANTANDER)

			this.ScoreItau = itau?.score
			this.ScoreBradesco = bradesco?.score
			this.ScoreSantander = santander?.score
			this.SPCScore = spcScore
		}

		private soma(): number {
			var soma = 0
			switch (this.ScoreItau) {
				case Bancos.RATING_ITAU.BA2:
					soma += 13
					break
				case Bancos.RATING_ITAU.B2:
					soma += 11
					break
				case Bancos.RATING_ITAU.B3:
					soma += 5
					break
				case Bancos.RATING_ITAU.C1:
					soma += 3
					break
				case Bancos.RATING_ITAU.C3:
					soma += 2
					break
			}

			switch (this.ScoreBradesco) {
				case Bancos.RATING_BRADESCO.APTO:
					soma += 13
					break
				case Bancos.RATING_BRADESCO.NAO_APTO:
					soma += 2
					break
				default:
					soma += 7
					break
			}

			switch (this.ScoreSantander) {
				case Bancos.RATING_SANTANDER.APTO:
					soma += 13
					break
				case Bancos.RATING_SANTANDER.NAO_APTO:
					soma += 2
					break
				default:
					soma += 7
					break
			}

			if (this.SPCScore) {
				if (this.SPCScore > 800) soma += 13
				else if (this.SPCScore > 600) soma += 11
				else if (this.SPCScore > 400) soma += 5
				else if (this.SPCScore > 200) soma += 3
				else if (this.SPCScore > 0) soma += 2
			}

			return soma
		}

		/**
		 * Retorna o valor em formato texto de A a E
		 */
		get(): RatingAtta {
			let soma = this.soma()

			if (soma >= RatingAttaPts.A) return RatingAtta.A
			if (soma >= RatingAttaPts.B) return RatingAtta.B
			if (soma >= RatingAttaPts.C) return RatingAtta.C
			if (soma >= RatingAttaPts.E) return RatingAtta.D

			return RatingAtta.E
		}

		/**
		 * Retorna o rating em pontos de 0 a 30
		 */
		getPts(): number {
			return this.soma()
		}
	}

	export interface IProgressoFormularioBancoItem {
		bancoId: number
		camposObrigatorios: Array<string>
	}

	export class ProgressoFormularioBancoItem implements IProgressoFormularioBancoItem {
		bancoId: number
		camposObrigatorios: string[]

		constructor(_bancoId: number, _camposObrigatorios: string[]) {
			this.bancoId = _bancoId
			this.camposObrigatorios = _camposObrigatorios
		}
	}

	export interface IAnalise {
		parametro: number
		analiseId: string
		motivo: string
	}

	export interface IProgressoFormularioResult {
		entidadeId: string
		valuePreenchidos: number
		valueNotPreenchidos: number
		totalCamposObrigatorios: number
		camposNaoPreenchidos: Array<string>
		percentPreenchidos: number
		percentNaoPreenchidos: number
	}

	export interface IProgressoFormularioFieldItem {
		field: string
		filled: boolean
		value: any
	}

	export interface IAttaTipoDocumentosItem {
		id: number
		descricao: string
	}

	export interface IDocumentFileUploadDocumentoItem {
		tipoDocumento: number
		quantidade: number
	}

	export interface IDocumentClientItem {
		id: string
		key: string
		cpf: number
		topico: number
		entidadeId: string
		tipoDocumento: number
		tamanho: number
		extensao: string
		contentType: string
		_OCR: string
		ocr: string
		enviadoEm: string
	}

	export interface IParceiroListItem {
		nome: String
		id: Number
		categoriaId: Number
		categoriaNome: String
		franquiaId: Number
		franquiaNome: String
	}

	export interface IUsuario {
		nome: string
		email: string
		id: number
	}

	export namespace API {
		export namespace Response {
			export interface IAttaListaTipoDocumentos extends Generico.IApiResponse<Array<IAttaTipoDocumentosItem>> {}
			export interface IClienteListaDocumentos extends Generico.IApiResponse<Array<IDocumentClientItem>> {}
			export interface IListaUsuarios extends Generico.IApiResponse<Array<IUsuario>> {}
			export interface IListaParceiros extends Generico.IApiResponse<Array<IParceiroListItem>> {}
			export interface IListaCidades extends Generico.IApiResponse<Array<ICidadeItem>> {}
		}

		export namespace Request {
			export interface IDocumentFileUploadRequest {
				documentos: Array<IDocumentFileUploadDocumentoItem>
				solicitacaoId?: string
				refId: string
				topico: number
				observacao: string
			}

			export interface AddClienteRequest {
				proponenteUm: ICliente
				proponenteUmConjuge: ICliente
				proponenteDois: ICliente
				proponenteDoisConjuge: ICliente

				[key: string]: any
			}

			export interface IIncluirCanalFranquia {
				canalId: number
				franquiaId: number
				fornecedorId: number
				produtoId: number
			}
		}
	}

	export interface IDadosBancarios {
		idBanco: number | null
		nrAgencia: string | null
		nrDigitoAgencia: number | null
		nrConta: string | null
		nrDigitoConta: number | null
	}

	export class DadosBancarios implements IDadosBancarios {
		idBanco: null = null
		nrAgencia: null = null
		nrDigitoAgencia: null = null
		nrConta: null = null
		nrDigitoConta: null = null
	}

	export interface IViaCepResponse {
		cep: string
		bairro: string
		uf: string
		logradouro: string
		localidade: string
		numero: string
		complement: string
	}

	export class ViaCepResponse implements IViaCepResponse {
		cep: string = ''
		bairro: string = ''
		uf: string = ''
		logradouro: string = ''
		localidade: string = ''
		numero: string = ''
		complement: string = ''
	}

	export interface ICidadeItem {
		id: number
		nome: string
	}
}
